var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('system-tabs',{attrs:{"tabs":_vm.tabs}},[_c('template',{slot:"help"},[_c('helpBrowser')],1),_c('template',{slot:"w1"},[_c('interface-browser',{attrs:{"tabs":_vm.browserTabs},on:{"event":_vm.onEvent}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }